import { render, staticRenderFns } from "./TrainersList.vue?vue&type=template&id=f527344e&"
import script from "./TrainersList.vue?vue&type=script&lang=js&"
export * from "./TrainersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrainersList.vue"
export default component.exports